import {PaginationDto} from 'src/app/shared/models/paginationDto'
import {Component, inject, OnDestroy, OnInit} from '@angular/core'
import {combineLatest, Observable, of, Subject} from 'rxjs'
import {filter, switchMap, takeUntil} from 'rxjs/operators'
import {AsyncPipe, NgIf} from '@angular/common'
import {FiltersComponent} from "../../../shared/ui/filters/filters.component";
import {CollaborateurGlobalDto} from "src/app/shared/models/collaborateursDto";
import {EquipeGlobaleDomainService} from "../../domain/equipeglobale.domain";
import {localeFr} from "../../../../assets/localization/ag-grid/ag-grid-locale-fr";
import {ColDef} from "ag-grid-community";
import {AgGridAngular} from "ag-grid-angular";

@Component({
    selector: 'app-equipe-globale',
    templateUrl: './equipe-globale.component.html',
    styleUrls: ['./equipe-globale.component.scss'],
    imports: [NgIf, FiltersComponent, AsyncPipe, AgGridAngular],
})
export class EquipeGlobaleComponent implements OnInit, OnDestroy {
    public equipeGlobalePaginated$!: Observable<Array<CollaborateurGlobalDto>>
    public resultsNumber: number = 0
    private equipeGlobaleDomainService = inject(EquipeGlobaleDomainService)
    equipeGlobale$: Observable<Array<CollaborateurGlobalDto>> = this.equipeGlobaleDomainService.equipeGlobaleSearchResults$
    equipeGlobalNumber$: Observable<number> = this.equipeGlobaleDomainService.equipeGlobalNumber$ //TODO weird
    equipeGlobaleLoading$: Observable<boolean> = this.equipeGlobaleDomainService.equipeGlobaleStateLoading$
    pagination$: Observable<PaginationDto> = this.equipeGlobaleDomainService.searchResultPagination$
    private unsubscribe$ = new Subject<void>()

    colDefs: ColDef[] = [
        {
            headerName: 'Collaborateurs',
            valueGetter: (params) =>
                params.data.nomCollaborateur +
                ' ' +
                params.data.prenomCollaborateur,
            flex: 2,
            sort: 'asc',
            sortIndex: 0, // Première clé de tri
        },

        {
            headerName: 'Emploi repère',
            valueGetter: (params) => params.data.nomEmploi,
            flex: 2.5,
        },
        {
            headerName: 'Direction / agence / service',
            valueGetter: (params) => params.data.nomEntiteAffectation,
            flex: 2,
        },
        {
            headerName: 'Manager actuel',
            valueGetter: (params) => {
                if (!params.data) {
                    return '';
                }
                const managerName = params.data.nomEtPrenomSuperieurHierarchique;
                if (params.data.managerHierarchiqueSorti) {
                    return managerName ? `${managerName} (collaborateur sorti)` : '(collaborateur sorti)';
                }
                return managerName;
            },
            flex: 2.2
        },
        {
            headerName: "Dans l'équipe depuis",
            valueGetter: (params) => params.data.dateDebutEquipe,
            flex: 1.8,
            resizable: false,
        },
    ]

    defaultColDef: ColDef = {
        sortable: true,
        unSortIcon: true,
        suppressHeaderMenuButton: true,
        suppressHeaderContextMenu: true,
        filter: 'agTextColumnFilter',
        filterParams: { maxNumConditions: 1, filterOptions: ['contains', 'equals', 'notContains', 'notEqual'] },
    }

    constructor() {
        // Get list of all collabs, on first load.
        this.equipeGlobaleDomainService.searchEquipeGlobale()
    }

    ngOnInit(): void {
        this.equipeGlobaleDomainService.searchReset()
        this.equipeGlobalePaginated$ = combineLatest([
            this.equipeGlobale$,
            this.pagination$,
            this.equipeGlobaleLoading$,
            this.equipeGlobalNumber$,
        ]).pipe(
            takeUntil(this.unsubscribe$),
            filter((results: any) => results[2].loading !== true && results[0]),
            switchMap((results: any) => {
                const monEquipe = results[0]
                const pagination = results[1]
                this.resultsNumber = results[3]

                return of(
                    monEquipe.slice(
                        pagination.pageNumber * pagination.pageSize,
                        (pagination.pageNumber + 1) * pagination.pageSize,
                    ),
                )
            }),
        )
        this.equipeGlobalePaginated$.subscribe()
    }

    /**
     * Pagination
     */
    public changePage(pageNumber: number) {
        this.equipeGlobaleDomainService.paginate(pageNumber)
    }

    ngOnDestroy() {
        this.unsubscribe$.next()
        this.unsubscribe$.complete()
    }

    public sortDataOn(event: any) {
        this.equipeGlobaleDomainService.sortSearch(event)
    }

    protected readonly localeFr = localeFr
}
